const steps = [
  {
    num: 1,
    title: 'Create Your Dairy',
    desc: 'Request access and create your MilkFlow dairy account.',
  },
  {
    num: 2,
    title: 'Set Up Your Business',
    desc: 'Add milk types, products, subscribers and subscription rules.',
  },
  {
    num: 3,
    title: 'Start Managing',
    desc: 'Manage subscriptions, deliveries, orders and customers from one dashboard.',
  },
]

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="mf-section mf-how-it-works">
      <div className="mf-container">
        <h2 className="mf-section-title mf-reveal">How MilkFlow Works</h2>
        <p className="mf-section-subtitle mf-reveal">
          Get started in three simple steps and begin managing your dairy in minutes.
        </p>

        <div className="mf-steps">
          {steps.map((s, i) => (
            <div key={i} className="mf-step mf-reveal" style={{ transitionDelay: `${i * 0.15}s` }}>
              <div className="mf-step-number">{s.num}</div>
              <div className="mf-step-card">
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
